export default function SearchForm({ profile, onProfileChange, onSearch, isLoading }) {
  return (
    <form
      className="search-form"
      onSubmit={(event) => {
        event.preventDefault();
        onSearch();
      }}
    >
      <label htmlFor="profile" style={{ 
        display: "block", 
        marginBottom: "0.5rem", 
        fontWeight: 600, 
        color: "var(--text-primary)",
        fontSize: "1rem"
      }}>
        Descreva o perfil do imóvel desejado
      </label>
      <textarea
        id="profile"
        rows={5}
        placeholder="Ex: casa com piscina, 4 quartos, 3 garagens, perto de escolas, área de lazer completa..."
        value={profile}
        onChange={(event) => onProfileChange(event.target.value)}
        style={{ 
          resize: "vertical",
          minHeight: "120px",
          fontFamily: "inherit"
        }}
      />
      <button 
        className="btn-primary" 
        type="submit" 
        disabled={isLoading || !profile.trim()}
        style={{ 
          width: "100%",
          marginTop: "0.5rem"
        }}
      >
        {isLoading ? "🔍 Buscando..." : "🚀 Buscar com IA"}
      </button>
    </form>
  );
}
